export default "__VITE_ASSET__BmUeHw4g__"